module.exports = __webpack_public_path__ + "static/media/img_milestone2.666c8bd5.jpg";